<template>
  <v-layout row wrap justify-center align-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-layout row wrap align-end>
            <v-flex xs12>
              <h1 v-if="step2Data.name">Cadastro de projetos - {{step2Data.name}}</h1>
              <h1 v-if="!step2Data.name">Cadastro de projetos</h1>
              <v-spacer></v-spacer>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-stepper v-model="e1" alt-labels v-if="!isMakerlab">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="e1 > 1">Tipo</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" :complete="e1 > 2">Básico</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3" :complete="e1 > 3">Atividades</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="4" :complete="e1 > 4">Auto Avaliação</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="5">Submeter</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1" >
                    <step1 @next="e1 = 2" 
                    v-on:result="result"
                    @dadoUnidade="dadoUnidade"
                    @dados1="step1Atual">
                    </step1>
                  </v-stepper-content>
                  <v-stepper-content step="2" v-if="atualizar">
                    <step2
                      @next="e1 = 3"
                      @prev="preview"
                      @next2="e1 = 4"
                      v-on:result="result"
                      :step1Data="step1Data"
                      :criterios="criterios"
                      :unidade="unidade"
                      :dialog_criterios="dialog_criterios"
                      @dados2="step2Atual"
                      @dadoAluno="alunoAtual"
                      @dadoFoto="fotoAtual"
                    ></step2>
                  </v-stepper-content>
                  <v-stepper-content step="3">
                    <step3
                      @next="e1 = 4"
                      @prev="preview"
                      v-on:result="result"
                      @dados3="step3Atual"
                      @dadotarefa="tarefaAtual"
                      @indicador="contador"
                      :criterios="criterios"
                      :atividades="atividades"
                    ></step3>
                  </v-stepper-content>
                  <v-stepper-content step="4" v-if="atualizar">
                    <step4
                      @next="e1 = 5"
                      @prev="preview"
                      v-on:result="result"
                      @dados4="step4Atual"
                      @dadotarefa="tarefaAtual"
                      :step3Data="step3Data"
                      :criterios="criterios"
                      :cont="i"
                      :tarefasModel="tarefas"
                    ></step4>
                  </v-stepper-content>
                  <v-stepper-content step="5">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>Deseja finalizar o cadastro?</h2>
                        <br>
                        <v-flex xs6>
                          <p>
                            <strong>Nome:</strong>
                            {{ step2Data.name }}
                          </p>
                          <br>
                          <p>
                            <strong>Descrição:</strong>
                            {{ step2Data.description }}
                          </p>
                          <br>
                          <p>
                            <strong>Objetivo:</strong>
                            {{ step2Data.objetivo }}
                          </p>
                          <br>
                          <p>
                            <strong>Justificativa:</strong>
                            {{ step2Data.justificativa }}
                          </p>
                          <br>
                          <p>
                            <strong>Recursos:</strong>
                            {{ step2Data.recursos }}
                          </p>
                          <br>
                        </v-flex>
                      </v-flex>
                      <v-layout align-center justify-end row fill-height>
                        <v-btn color="primary" v-if="!makerLab" @click.native="preview">voltar</v-btn>
                        <v-btn color="primary" v-if="makerLab" @click.native="e1 = 3">voltar</v-btn>
                        <v-btn color="primary" :loading="animation" @click.native="cadastrar">
                          <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                          <span v-else>Finalizar</span>
                        </v-btn>
                      </v-layout>
                    </v-layout>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
              <v-stepper v-model="e1" alt-labels v-if="isMakerlab">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="e1 > 1">Tipo</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" :complete="e1 > 2">Atividades</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="3" :complete="e1 > 3">Auto Avaliação</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="4">Submeter</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1">
                    <step1-lab @next="e1 = 2" 
                    v-on:result="result"
                    @dadoUnidade="dadoUnidade"
                    @dados1="step1Atual">
                    </step1-lab>
                  </v-stepper-content>
                  <v-stepper-content step="2">
                    <step3
                      @next="e1 = 3"
                      @prev="preview"
                      v-on:result="result"
                      @dados3="step3Atual"
                      @dadotarefa="tarefaAtual"
                      @indicador="contador"
                      :criterios="criterios"
                      :atividades="atividades"
                    ></step3>
                  </v-stepper-content>
                  <v-stepper-content step="3" v-if="atualizar">
                    <step3-lab
                      @next="e1 = 4"
                      @prev="preview"
                      v-on:result="result"
                      @dados4="step4Atual"
                      @dadotarefa="tarefaAtual"
                      :step3Data="step3Data"
                      :criterios="criterios"
                      :cont="i"
                      :tarefasModel="tarefas"
                    ></step3-lab>
                  </v-stepper-content>
                  <v-stepper-content step="4">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2>Deseja finalizar o cadastro?</h2>
                        <br>
                        <v-flex xs6>
                          <p>
                            <strong>Nome:</strong>
                            {{ step1Data.name }}
                          </p>
                          <br>
                          <p>
                            <strong>Descrição:</strong>
                            {{ step1Data.description }}
                          </p>
                          <br>
                          <p>
                            <strong>Objetivo:</strong>
                            {{ step1Data.objetivo }}
                          </p>
                        </v-flex>
                      </v-flex>
                      <v-layout align-center justify-end row fill-height>
                        <v-btn color="primary" v-if="!makerLab" @click.native="preview">voltar</v-btn>
                        <v-btn color="primary" v-if="makerLab" @click.native="e1 = 3">voltar</v-btn>
                        <v-btn color="primary" :loading="animation" @click.native="cadastrarLab">
                          <v-progress-circular indeterminate color="primary" v-if="loading"></v-progress-circular>
                          <span v-else>Finalizar</span>
                        </v-btn>
                      </v-layout>
                    </v-layout>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import api from '@/api';
import Step1 from './CadastroSteps/Step1.vue';
import Step1Lab from './CadastroSteps/Step1Lab.vue';
import Step2 from './CadastroSteps/Step2.vue';
import Step3Lab from './CadastroSteps/Step3Lab.vue';
import Step3 from './CadastroSteps/Step3.vue';
import Step4 from './CadastroSteps/Step4.vue';
export default {
  components: {
    Step1,
    Step1Lab,
    Step2,
    Step3,
    Step3Lab,
    Step4
  },
  data () {
    return {
      e1: 1,
      step1Data: [],
      step2Data: [],
      step3Data: [],
      step4Data: [],
      selectFile: {},
      tarefas: [],
      atividades: [],
      i: 0,
      alunos: [],
      atualizar: true,
      integrantes: [],
      projetoID: '',
      habil: false,
      loading: false,
      animation: false,
      dialog_criterios: false,
      makerLab: false,
      criterios: [],
      unidade: [],
      dadosAtividades: [],
      payload: {},
      teste: ['teste1', '2'],
      result: {}
    };
  },
  mounted () {
    this.getcriterio();
    this.$watch('step1Data', function () {
      this.atualizar = false
      console.log('watch')
      this.atualizar = true
      if (this.step1Data.length !== null) {
        this.getTarefa();
        this.getAtividades();
      }
    });

    this.$watch('step3Data', function () {
      this.atualizar = false;
      this.atualizar = true;
    });
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    target () {
      return 0;
    },
    options () {
      return {
        duration: 0,
        offset: 0
      };
    }
  },
  methods: {
    step1Atual (result) {
      this.step1Data = result
      console.log('step1', this.step1Data);
      this.$vuetify.goTo(this.target, this.options);
    },
    step2Atual (result) {
      this.step2Data = result;
      console.log('step2', this.step2Data);
      this.$vuetify.goTo(this.target, this.options);
    },
    step3Atual (result) {
      this.step3Data = result;
      console.log('step3', this.step3Data);
      this.contador();
      this.$vuetify.goTo(this.target, this.options);
    },
    step4Atual (result) {
      this.step4Data = result;
      console.log('step 4', this.step4Data);
      this.$vuetify.goTo(this.target, this.options);
    },
    alunoAtual (result) {
      this.integrantes = result;
    },
    fotoAtual (result) {
      this.selectFile = result;
    },
    tarefaAtual (result) {
      this.step1Data['tarefas_obrigatorias'] = result;
      console.log('tarefa', result);
    },
    dadoUnidade (unidade) {
      console.log('unidade', unidade)
      this.unidade = unidade
    },
    contador () {
      this.atualizar = false;
      this.i = this.i + 1;
      console.log('i', this.i);
      this.atualizar = true;
    },
    selectID (item) {
      item.habilidades_pks = item.habilidades.map(valor => {
        return valor.id;
      });
      return item;
    },
    preview () {
      this.e1 = this.e1 - 1;
      this.$vuetify.goTo(this.target, this.options);
    },
    getTarefa () {
      api
        .request(
          'GET',
          'modeloTarefas/?modelo_projetos__id=' + this.step1Data.id
        )
        .then(response => {
          this.tarefas = response.data;
          // console.log('tarefas', response.data)
        });
    },
    getAtividades () {
      api
        .request(
          'GET',
          'modelo-atividades/?modelo_projetos__id=' + this.step1Data.id
        )
        .then(response => {
          this.atividades = response.data;
          // console.log('atividades', response.data)
        });
    },
    getcriterio () {
      api
        .request('GET', 'criterioavaliacao/')
        .then(response => {
          this.criterios = response.data;
        })
        .then(() => {
          this.dialog_criterios = true;
        });
    },
    cadastrar () {
      this.dados = this.step4Data.map(this.selectID);
      this.dadosAtividades = this.step3Data.map(this.selectID);
      if (this.makerLab) {
        this.dados = this.tarefas;
      }
      this.animation = true;
      api
        .request('POST', 'projetos/', this.step2Data)
        .then(response => {
          this.projetoID = response.data.id;
          if (this.dados.length > 0) {
            for (let index = 0; index < this.dados.length; index++) {
              this.dados[index]['projeto'] = response.data.id;
              api.request('POST', 'tarefas/', this.dados[index]).then(resp => {
                // console.log(resp.data)
              });
            }
          }
          if (this.integrantes.length > 0) {
            for (let index = 0; index < this.integrantes.length; index++) {
              this.alunos[index] = {
                integrante: this.integrantes[index],
                projeto: this.projetoID
              };
              api
                .request('POST', 'integrante/', this.alunos[index])
                .then(resp => {
                  // console.log(resp.data)
                });
            }
          }
          if (this.dadosAtividades.length > 0) {
            for (let index = 0; index < this.dadosAtividades.length; index++) {
              this.dadosAtividades[index]['projeto'] = this.projetoID;
              api
                .request('POST', 'atividade/', this.dadosAtividades[index])
                .then(resp => {
                  // console.log(resp.data)
                });
            }
          }
          if (
            this.step2Data.image !== 0 &&
            this.selectFile.size === undefined
          ) {
            let route = '/projetos/' + this.projetoID;
            this.animation = false;
            this.$router.push(route);
          }
          if (this.selectFile.size !== undefined) {
            var extension = this.selectFile.name.split('.').pop();

            var name =
              'images/projetos/projectPic_' +
              response.data.id +
              '.' +
              extension;
            var upload = this.fbstorage.child(name).put(this.selectFile);

            upload.on(
              'state_changed',
              snapshot => {},
              error => console.log(error),
              url => {
                var payload = { image: name };
                var path = 'projetos/' + response.data.id + '/';
                // console.log(path)

                api
                  .request('PATCH', path, payload)
                  .then(response => {
                    let route = '/projetos/' + response.data.id;
                    this.animation = false;
                    this.$router.push(route);
                  })
                  .catch(function (error) {
                    console.log(error);
                    this.animation = false;
                  });
              }
            );
          } else {
            var formato = this.step2Data.image.split('_').pop();
            var id = formato.split('.');
            formato = formato.split('?alt=media');
            formato = formato[0].split('.');
            var fotoPadrao =
              'images/padroes/padraoPic_' + id[0] + '.' + formato[1];
            var payload = { image: fotoPadrao };
            var path = 'projetos/' + response.data.id + '/';
            api
              .request('PATCH', path, payload)
              .then(response => {
                let route = '/projetos/' + response.data.id;
                this.animation = false;
                this.$router.push(route);
              })
              .catch(function (error) {
                console.log(error);
                this.animation = false;
              });
          }

          this.imageChangeModal = false;
        })
        .catch(function (error) {
          console.log(error);
          this.animation = false;
        });
    },
    cadastrarLab () {
      this.dados = this.step4Data.map(this.selectID);
      this.dadosAtividades = this.step3Data.map(this.selectID);
      if (this.makerLab) {
        this.dados = this.tarefas;
      }
      this.animation = true;
      api
        .request('POST', 'projetos/', this.step1Data)
        .then(response => {
          this.projetoID = response.data.id;
          if (this.dados.length > 0) {
            for (let index = 0; index < this.dados.length; index++) {
              this.dados[index]['projeto'] = response.data.id;
              api.request('POST', 'tarefas/', this.dados[index]).then(resp => {
                // console.log(resp.data)
              });
            }
          }
          if (this.integrantes.length > 0) {
            for (let index = 0; index < this.integrantes.length; index++) {
              this.alunos[index] = {
                integrante: this.integrantes[index],
                projeto: this.projetoID
              };
              api
                .request('POST', 'integrante/', this.alunos[index])
                .then(resp => {
                  // console.log(resp.data)
                });
            }
          }
          if (this.dadosAtividades.length > 0) {
            for (let index = 0; index < this.dadosAtividades.length; index++) {
              this.dadosAtividades[index]['projeto'] = this.projetoID;
              api
                .request('POST', 'atividade/', this.dadosAtividades[index])
                .then(resp => {
                  // console.log(resp.data)
                });
            }
          }
          var formato = this.step1Data.image.split('_').pop();
          var id = formato.split('.');
          formato = formato.split('?alt=media');
          formato = formato[0].split('.');
          var fotoPadrao =
              'images/padroes/padraoPic_' + id[0] + '.' + formato[1];
          var payload = { image: fotoPadrao };
          var path = 'projetos/' + response.data.id + '/';
          api
              .request('PATCH', path, payload)
              .then(response => {
                let route = '/projetos/' + response.data.id;
                this.animation = false;
                this.$router.push(route);
              })
              .catch(function (error) {
                console.log(error);
                this.animation = false;
              });

          this.imageChangeModal = false;
        })
        .catch(function (error) {
          console.log(error);
          this.animation = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Projetos/Cadastro.vue